<div class="container-fluid position-relative" style="height: 90vh;">
    <div class="d-flex justify-content-center align-items-center flex-column"
        style="left: 50%;top: 50%;position: absolute;transform: translate(-50%,-50%);">
        <span class="material-icons text-danger">sentiment_dissatisfied</span>
        <h3 class="m-0">The page you are looking not found</h3>
    </div>

</div>